import { render } from "./SmartBarcodeIcon.vue?vue&type=template&id=9f5c904e"
import script from "./SmartBarcodeIcon.vue?vue&type=script&lang=ts"
export * from "./SmartBarcodeIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script